<template>
  <v-app>
    <div style="padding-top:60px; min-height: 100vh">
      <router-view @snackbar="handleSnackbar" />
      <v-snackbar
        v-model="snackbar"
        data-cy="snackbar-error-bar"
        :timeout="timeout"
        color="white"
        top
      >
        <v-row
          no-gutters
          align="center"
          justify="space-between"
        >
          <v-col cols="auto">
            <span :style="{color}"> {{ text }} </span>
          </v-col>
          <v-col cols="auto">
            <v-btn
              text
              color="secondary"
              @click.native="snackbar = false"
            >
              Close
            </v-btn>
          </v-col>
        </v-row>
      </v-snackbar>
    </div>
  </v-app>
</template>

<script>
import AppBarLogo from './assets/logo-long.svg';

export default {
  name: 'App',

  data: () => ({
    snackbar: false,
    timeout: null,
    text: null,
    color: null,
    AppBarLogo,
  }),
  methods: {
    handleSnackbar({ text, timeout = 2000, color = 'green' }) {
      this.timeout = timeout;
      this.text = text;
      this.color = color;
      this.snackbar = true;
    },
  },
};
</script>

<style scoped lang="scss">
  @import '@/scss/design';

  .date-row {
    border-bottom: 1px solid $gray-light;
  }

  .footer-button {
    text-decoration: none;
    color:white
  }
</style>
